import { jsx as _jsx } from "react/jsx-runtime";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import * as contactSelectors from "@rentiohq/shared-frontend/dist/redux/contact/contact.selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContactListItem } from "../ContactListItem";
import { SpinningLoader } from "../SpinningLoader";
export var ContactList = function (_a) {
    var _b = _a.contactIds, contactIds = _b === void 0 ? [] : _b, getSubtitle = _a.getSubtitle, getActions = _a.getActions;
    var dispatch = useDispatch();
    var isFetching = useSelector(function (state) {
        return contactSelectors.getContactsIsFetching(state);
    });
    var allDidFetch = useSelector(function (state) {
        return contactSelectors.getContactsAllDidFetch(state, contactIds);
    });
    var contacts = useSelector(function (state) {
        return contactSelectors.getContactsByIds(state, contactIds);
    });
    React.useEffect(function () {
        if (contactIds.length === 0 || isFetching || allDidFetch)
            return;
        dispatch(contactActions.getContactsByAccountIds.actions.start({
            accountIds: contactIds,
        }));
    }, [contactIds]);
    if (isFetching) {
        return _jsx(SpinningLoader, {});
    }
    return (_jsx(Stack, { direction: "column", gap: 2, divider: _jsx(Divider, { orientation: "horizontal" }), children: (contacts || []).filter(Boolean).map(function (contact) { return (_jsx(ContactListItem
        // @ts-ignore
        , { 
            // @ts-ignore
            contact: contact, getSubtitle: getSubtitle, getActions: getActions })); }) }));
};
